<template>
  <div id="DaStudent">
      <div ref="userOver" style="height:150px"></div>

      <div ref="getUserYearForGard" style="height:400px;"></div>

      <div ref="getUserYear" style="height:400px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        loading: true,
        apiPath: '/api/UserChart/',
        datas: [],
        titles: [],


        chartOverView: null,
        chartGetUserYearForGard: null,
        chartGetUserYear: null,
    };
  },
  components: {},
  created: function() {
    this.getChart();
  },
  mounted: function() {
    
        this.GetUserYearForGard();
        this.GetUserYear();

        window.onresize = function () {

            this.chartOverView.resize();
            this.chartGetUserYearForGard.resize();
            this.chartGetUserYear.resize();
        };
  },
  methods: {

        //概览
        async getChart () {
          
          let res = await this.xyapi.get(
            this.$store.state.apiPath + this.apiPath + 'GetUserOverView'
          );
          //加载学科
          this.datas = [];
          this.titles = [];
          let totalCount = 0;
          if (res&&res.data.Data.length > 0) {
              res.data.Data.forEach( (value)=> {
                  totalCount += value.Count;
                  this.datas.push({ value: value.Count, name: value.SexName });
                  this.titles.push(value.SexName);
              });


              let option = {
                  title: {
                      text: "学生数:" + totalCount + "人",
                      textStyle: {
                          color: '#95C5E4'
                      },
                      x: 'center',
                      y: 'center'
                  },
                  //graphic: {
                  //    type: 'text',
                  //    left: "center",
                  //    top: "center",
                  //    z: 2,
                  //    zLevel: 100,
                  //    style: {
                  //        text: "学生数:" + totalCount + "人",
                  //        x: 100,
                  //        y: 100,
                  //        textAlign: 'center',
                  //        fill: 'bule',
                  //        width: 70,
                  //        height: 700,
                  //    }
                  //},
                  tooltip: {
                      trigger: 'item',
                      formatter: "{a} <br/>{b}: {c} ({d}%)"
                  },
                  legend: {
                  },
                  series: [
                      {
                          name: '人数',
                          type: 'pie',
                          radius: ['50%', '70%'],
                          avoidLabelOverlap: false,
                          label: {
                              normal: {
                                  show: false,
                                  position: 'center'
                              },
                              emphasis: {
                                  show: true,
                                  textStyle: {
                                      fontSize: '30',
                                      fontWeight: 'bold'
                                  }
                              }
                          },
                          labelLine: {
                              normal: {
                                  show: false
                              }
                          },
                          data: this.datas
                      }
                  ]
              };

              this.chartOverView = this.echarts.init(this.$refs.userOver);
              //使用制定的配置项和数据显示图表
              this.chartOverView.setOption(option);

          }


        },


        //年级学生--柱状图
        async GetUserYearForGard () {
            // 基于准备好的dom，初始化echarts实例
            this.chartGetUserYearForGard = this.echarts.init(this.$refs.getUserYearForGard);
            // 指定图表的配置项和数据
            let option = {
                title: {
                    text: '年级学生'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                legend: {
                    //data: ['直接访问', '邮件营销','联盟广告','视频广告','搜索引擎']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value'
                },
                //年级
                yAxis: {
                    type: 'category',
                    data: [],//['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                },
                series: [
                    {
                        name: '男',
                        type: 'bar',
                        stack: '总量',
                        label: {
                            normal: {
                                show: true,
                                position: 'insideRight'
                            }
                        },
                        data: [0, 0, 301, 334, 390, 330, 320]
                    },
                    {
                        name: '女',
                        type: 'bar',
                        stack: '总量',
                        label: {
                            normal: {
                                show: true,
                                position: 'insideRight'
                            }
                        },
                        data: [120, 132, 101, 134, 90, 230, 210]
                    },

                ]
            };
            // 使用刚指定的配置项和数据显示图表。
            //this.chartGetUserYearForGard.setOption(option);
            this.chartGetUserYearForGard.showLoading();

            let res = await this.xyapi.get(
              this.$store.state.apiPath + this.apiPath + 'GetUserYearForGard'
            );
            if (res&&res.success) {

                //let xAxisDataList = [];
                let yAxisDataList = [];
                // let seriesDataList = [];

                let sexFalseList = [];
                let sexTrueList = [];

                res.data.forEach( (item)=> {
                    //如果没有此年级,添加
                    if (yAxisDataList.indexOf(item.YearForGardName) < 0) {
                        yAxisDataList.push(item.YearForGardName);
                    }

                    if (item.Sex) {
                        sexTrueList.push(item.Count);
                    } else {
                        sexFalseList.push(item.Count);
                    }
                });

                option.yAxis.data = yAxisDataList.reverse();
                option.series[0].data = sexTrueList.reverse();
                option.series[1].data = sexFalseList.reverse();

                this.chartGetUserYearForGard.hideLoading();
                this.chartGetUserYearForGard.setOption(option, true);


            } else {
              this.xy.msgError(res.msg);
                // MainVue.$Modal.error({ title: "错误信息", content: res.msg });
            }

        },

        // //近3年学生入学--折线图
        async GetUserYear () {
            this.chartGetUserYear = this.echarts.init(this.$refs.getUserYear);
            let option = {
                title: {
                    text: '近3年入学人数'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: [],//['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    minInterval: 1,
                    type: 'value'
                },
                series: [{
                    data: [],//[820, 932, 901, 934, 1290, 1330, 1320],
                    type: 'line',
                    areaStyle: {}
                }]
            };

            // 使用刚指定的配置项和数据显示图表。
            this.chartGetUserYear.setOption(option);
            this.chartGetUserYear.showLoading();

            let res = await this.xyapi.get(
              this.$store.state.apiPath + this.apiPath + 'GetUserYear'
            );
            if (res&&res.success) {
                let xAxisDataList = [];
                let seriesDataList = [];
                res.data.forEach( (item) => {
                    xAxisDataList.push(item.YearName);
                    seriesDataList.push(item.Count);
                });
                option.xAxis.data = xAxisDataList;
                option.series[0].data = seriesDataList;

                this.chartGetUserYear.hideLoading();
                this.chartGetUserYear.setOption(option, true);
            } else {
              this.xy.msgError(res.msg);
                // MainVue.$Modal.error({ title: "错误信息", content: res.msg });
            }


        },
  }
};
</script>
<style lang='less' >
// #DaStudent {
  
// }
</style>

